import React, { useState } from "react";
import { useSelector } from "react-redux";
import MiniWidget from "../../../shared/components/features/widget/miniWidget/MiniWidget";
import CreateStudyGroupFlowWizard from "../createStudyGroup/createStudyGroupFlowWizard/CreateStudyGroupFlowWizard";

const CreateStudyGroupMiniWidget = ({ className, color = "#FDDB71" }) => {

    const { texts } = useSelector(state => state.translate);
    const [open, setOpen] = useState(false);

    const openWizard = (e) => {
        e?.stopPropagation();
        setOpen(true);
    };

    return (
        <>
            <MiniWidget
                color={color}
                text={texts.openNewStudyGroup}
                onClick={openWizard}
                className={className}
            />
            {open &&
                <CreateStudyGroupFlowWizard onClose={() => setOpen(false)} />
            }
        </>
    );
};

export default CreateStudyGroupMiniWidget;
